import Masonry from 'react-masonry-css';
import React from 'react';
import { twMerge } from 'tailwind-merge';

type Props = Partial<{
  length?: number;
  className?: string;
  style?: any;
  horizontal?: boolean;
  rows?: number;
  animation?: boolean;
}>;

export default function VerticalMasonryList(props: Props) {
  const { horizontal, className, animation } = props;

  if (horizontal) {
    return <div></div>;
  }

  return (
    <div>
      <Masonry
        breakpointCols={2}
        className={twMerge('flex flex-row w-auto -ml-4 pl-3', className)}
        columnClassName="w-1/2 pl-[5px]">
        {new Array(8).fill(0).map((item, index) => {
          return (
            <EnkiCard key={index} index={index} animation={animation} horizontal={horizontal} className="pt-[90%]" />
          );
        })}
      </Masonry>
    </div>
  );
}

export const EnkiCard: React.FC<{
  horizontal?: boolean;
  index?: number;
  className?: string;
  animation?: boolean;
}> = props => {
  const { horizontal, index: productIndex, className, animation } = props;
  if (horizontal) {
    return <div></div>;
  }
  return (
    <div className={twMerge('mb-4')}>
      <div
        className={twMerge('w-full h-full rounded-200', animation ? 'skeleton' : 'bg-surface-200-bg', className)}></div>
      <div className="px-2 pt-0.5 overflow-hidden">
        {[0, 1, 2].map((item, index) => {
          //第一个卡片的展示3行文案，其他卡片展示2行文案
          if (index === 2 && productIndex !== 0) {
            return null;
          }

          return (
            <div
              key={index}
              style={{ width: index === 2 ? '70%' : '100%' }}
              className={twMerge(
                'w-full h-[18px] rounded-200 mt-1.5 overflow-hidden',
                animation ? 'skeleton' : 'bg-surface-200-bg'
              )}></div>
          );
        })}
      </div>
    </div>
  );
};
